import { Type } from '@sinclair/typebox';
export const idDtoSchema = Type.Object({
    id: Type.String({
        example: '2cdc8ab1-6d50-49cc-ba14-54e4ac7ec231',
        description: "Entity's id",
    }),
});
export const baseResponseDtoSchema = Type.Composite([
    idDtoSchema,
    Type.Object({
        createdAt: Type.String(),
        updatedAt: Type.String(),
    }),
]);
export const BasicUserInfoSchema = Type.Object({
    delugeId: Type.String(),
    username: Type.String(),
    firstName: Type.Optional(Type.String()),
    lastName: Type.Optional(Type.String()),
    avatar: Type.Optional(Type.String()),
});
export const TokenCommentSchema = Type.Recursive((Comment) => Type.Composite([
    baseResponseDtoSchema,
    Type.Object({
        content: Type.String(),
        authorDelugeId: Type.String(),
        pairAddress: Type.String(),
        mentions: Type.Array(Type.String()),
        parentCommentId: Type.Optional(Type.String()),
        imageAttachment: Type.Optional(Type.String()),
        depth: Type.Number(),
        reactions: Type.Optional(Type.Record(Type.String(), // reaction type, e.g. "like"
        Type.Object({
            count: Type.Number(),
            users: Type.Array(Type.String()),
        }))),
        replies: Type.Optional(Type.Array(Comment)),
        totalReplies: Type.Number(),
    }),
]));
export const TokenCommentWithUsersInfoSchema = Type.Recursive((Comment) => Type.Composite([
    baseResponseDtoSchema,
    Type.Object({
        content: Type.String(),
        authorDelugeId: Type.String(),
        pairAddress: Type.String(),
        mentions: Type.Array(Type.String()),
        parentCommentId: Type.Optional(Type.String()),
        imageAttachment: Type.Optional(Type.String()),
        depth: Type.Number(),
        reactions: Type.Optional(Type.Record(Type.String(), Type.Object({
            count: Type.Number(),
            users: Type.Array(Type.String()),
        }))),
        replies: Type.Optional(Type.Array(Comment)),
        totalReplies: Type.Number(),
        author: BasicUserInfoSchema,
    }),
]));
export const TokenCommentsThreadSchema = Type.Array(TokenCommentSchema);
export const TokenCommentsThreadWithCountSchema = Type.Object({
    comments: Type.Array(TokenCommentSchema),
    totalCount: Type.Number(),
});
export const TokenCommentsSchema = Type.Array(TokenCommentSchema);
export const TokenCommentsWithUsersInfoSchema = Type.Array(TokenCommentWithUsersInfoSchema);
export const TokenCommentsWithUsersInfoWithCountSchema = Type.Object({
    comments: Type.Array(TokenCommentWithUsersInfoSchema),
    totalCount: Type.Number(),
});
export var ReactionType;
(function (ReactionType) {
    ReactionType["Like"] = "like";
    ReactionType["Dislike"] = "dislike";
})(ReactionType || (ReactionType = {}));
export const CommentsByDelugeIdPeriodSchema = Type.Union([
    Type.Literal('ALL'),
    Type.Literal('7D'),
    Type.Literal('24H'),
    Type.Literal('12H'),
    Type.Literal('6H'),
    Type.Literal('1H'),
]);
//# sourceMappingURL=types.js.map